import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import { TextareaAutosize } from "@mui/base";
import SearchDropDownListPaginationComponent from "../common/SearchDropDownPaginationList";
import { withTranslation } from "react-i18next";

const ChangeRequestMeta = (props) =>{
  const [priority, setPriority] = useState();

  useEffect(() => {
    setPriority({
      id: props.setChangeRequestMetaInfo?.priority.id,
      label: props.setChangeRequestMetaInfo?.priority.name,
      key: `${props.setChangeRequestMetaInfo?.priority.id}|${props.setChangeRequestMetaInfo?.priority.name}`,
    });
  }, []);

  return (
    <div>
      {/* <Card className="customCard changeReqCard p-3 my-3"> */}
      <div className="impact d-flex flex-column position-relative" style={{ marginBottom: '12px'}}>
        {/* <div className="impact d-flex flex-column position-relative"> */}
          {/* <label className="position-absolute abs-label">
          {props.t('Describe the change')} *
          </label> */}
          <TextareaAutosize
            className="position-relative"
            minRows="2"
            name="description"
            readOnly={true}
            value={props.setChangeRequestMetaInfo.description}
            required
          />
        {/* </div> */}
      </div>

      {/* <Card className="customCard changeReqCard p-3 my-3"> */}
      <div className="impact d-flex flex-column position-relative" style={{ marginBottom: '12px'}}>
        {/* <div className="impact d-flex flex-column position-relative">
          <label className="position-absolute abs-label">
          {props.t('Reason for the change')} *
          </label> */}
          <TextareaAutosize
            className="position-relative"
            minRows="2"
            name="reason"
            readOnly={true}
            value={props.setChangeRequestMetaInfo.reason}
            required
          />
      </div>
      

      {/* <Card className="customCard changeReqCard p-3 my-3"> */}
      <div className="impact d-flex flex-column position-relative" style={{ marginBottom: '12px'}}>
        {/* <div className="impact d-flex flex-column position-relative">
          <label className="position-absolute abs-label">
          {props.t('Impact for the change')} *
          </label> */}
          <TextareaAutosize
            className="position-relative"
            minRows="2"
            name="impact"
            readOnly={true}
            value={props.setChangeRequestMetaInfo.impact}
            required
          />
      </div>
      {/* </Card> */}

      <div style={{ marginBottom: '12px'}}>
        <SearchDropDownListPaginationComponent
          label={props.t("Priority Level") + '*'}
          required
          readOnly={true}
          searchEnabled={false}
          defaultValue={priority}
        />
      </div>

      {/* <Card className="customCard changeReqCard p-3 my-3"> */}
      <div className="impact d-flex flex-column position-relative" style={{ marginBottom: '12px'}}>
        {/* <div className="impact d-flex flex-column position-relative">
          <label className="position-absolute abs-label">
            {props.t('Specify the impact if the change request is not approved')} *
          </label> */}
          <TextareaAutosize
            className="position-relative"
            minRows="2"
            name="negativeImpact"
            readOnly={true}
            value={props.setChangeRequestMetaInfo.negativeImpact}
            required
          />
      </div>
      
    </div>
  );
}

export default withTranslation() (ChangeRequestMeta)
